export default __webpack_public_path__ + "static/media/FurnitureItem5.d218eceb.png";